import { useMutation, useQueryClient } from "react-query";
import { updateActionStatus } from "client-api-workflow";

const useUpdateActionStatus = () => {
	const queryClient = useQueryClient();

	return useMutation(
		async ({ id, status }: { id: string; status: string }) => {
			const result = await updateActionStatus(id, status);
			return result;
		},
		{
			onSuccess: () => {
				// Invalidate the actions query to refresh the list
				queryClient.invalidateQueries({
					predicate: (query) => query.queryKey.indexOf("actions") >= 0,
				});
			},
		}
	);
};

export default useUpdateActionStatus;

